(function() {
  'use strict';

  angular.module('app.pages', [
      'ui.router',
      'app.pages.main',
      'app.pages.dashboard'
    ])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, $stateProvider, $locationProvider, panelsProvider) {
    $urlRouterProvider.otherwise(function($injector) {
      var $state = $injector.get('$state');
      $state.go('main');
    });

    // use the HTML5 History API
    $locationProvider.html5Mode(true);

    panelsProvider
      .add({
        id: 'layersPanel',
        position: 'right',
        size: '350px',
        templateUrl: 'modules/sidepanel/sidePanel.html',
        controller: 'SidepanelCtrl'
      })

      .add({
        id: 'resultsPanel',
        position: 'right',
        size: '350px',
        templateUrl: 'modules/previewpanel/previewPanel.html',
        controller: 'PreviewPanelCtrl'
      });
  }

})();
